<template>
  <div>
    <form class="form" @submit.prevent="onSubmit">
      <fieldset class="form form--fieldset">
        <div class="form__group">
          <t-text v-model="form.surname" name="surname" label="Фамилия" required/>
          <t-text v-model="form.name" name="name" label="Имя" required/>
          <t-text v-model="form.patronymic" name="patronymic" label="Отчество"/>
        </div>

        <div class="form__group">
          <t-select v-model="form.gender" name="gender" label="Пол" :options="GENDERS" required/>
          <t-datepicker v-model="form.birthdate" name="birthdate" label="Дата рождения" required/>
          <t-phone v-model="form.phone" v-model:countryCode="form.phone_country" name="phone" label="Телефон" required/>
        </div>

        <div class="form__group">
          <t-select v-model="form.kind" name="kind" label="Уровень образования" :options="KINDS" required/>
          <div class="form__spacer"></div>
          <div class="form__spacer"></div>
        </div>
      </fieldset>

      <t-checkbox v-model="form.has_agreement" name="has_agreement">
        <div>
          Даю свое согласие на обработку своих персональных данных с целью проведения приемной кампании и обеспечения процесса
          обучения, в том числе на получение информационных сообщений посредством информационно-телекоммуникационных средств связи.
          <a @click="openModalInfo">Подробнее</a>
        </div>
      </t-checkbox>

      <transition name="fade">
        <modal-info v-if="isModalShow" @close="closeModalInfo"/>
      </transition>

      <div class="form__actions">
        <button class="btn btn--primary">Сохранить</button>
        <button class="btn btn--outline-primary" type="button" @click="redirectToRoot">Отмена</button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { TText, TSelect, TDatepicker, TPhone, TCheckbox } from '@shared/ui'
import { KINDS, GENDERS } from '@shared/config'
import { useAbiturientStore } from '@pages/abiturient'
import { useModal, useFormErrors, toast } from '@shared/lib'
import ModalInfo from './_ModalInfo.vue'

const props = defineProps({
  initialForm: { type: Object, required: true }
})

const router    = useRouter()
const formStore = useAbiturientStore()

const form = ref({ ...props.initialForm })
const { setErrors } = useFormErrors()

const { isModalOpen: isModalShow, openModal: openModalInfo, closeModal: closeModalInfo } = useModal()

const redirectToRoot = () => router.push({ name: 'abiturient.index', params: { tab: 'form' } })

const onSubmit = async () => {
  try {
    if (form.value.id) {
      await formStore.updateForm(form.value)
      toast.success('Анкета обновлена')
    } else {
      await formStore.createForm(form.value)
      gon.user.is_form_exist = true
      toast.success('Анкета создана')
    }
    router.push({ name: 'abiturient.index', params: { tab: 'form' } })
  } catch (error) {
    if (error.response?.data?.errors) {
      setErrors(error.response.data.errors.form)
    }
    toast.error('Произошла ошибка')
  }
}
</script>
